import { CssBaseline, ThemeProvider } from "@mui/material";
import PropTypes from "prop-types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetTheme } from "../hooks/useGetTheme";
import { darkenHex } from "../utils/colorUtils";
import { TranslationContext } from ".";

const FALLBACK_MAIN = "#10b981";
const FALLBACK_TEXT = "#ffffff";
const FALLBACK_HOVER = "#059669";

export const TranslationProvider = ({ children }) => {
  const { t, i18n } = useTranslation();
  const translationContextValue = useMemo(() => ({ t, i18n }), [t, i18n]);

  return (
    <TranslationContext.Provider value={translationContextValue}>
      {children}
    </TranslationContext.Provider>
  );
};
TranslationProvider.propTypes = {
  children: PropTypes.node,
};
export const MyThemeProvider = ({ children }) => {
  const theme = useGetTheme();
  const main = theme?.palette?.primary?.main ?? FALLBACK_MAIN;
  const text = theme?.palette?.primary?.contrastText ?? FALLBACK_TEXT;
  const hover = main?.startsWith("#") ? darkenHex(main, 25) : FALLBACK_HOVER;
  const focusRing = main ?? FALLBACK_MAIN;

  const buttonVars = {
    "--main-button-bg": main,
    "--main-button-text": text,
    "--main-button-hover": hover,
    "--main-button-focus-ring": focusRing,
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={buttonVars}>
        <CssBaseline />
        {children}
      </div>
    </ThemeProvider>
  );
};
MyThemeProvider.propTypes = {
  children: PropTypes.node,
};
